
const digest = 'a4c183d386a2c3e78328ee231eb5a4440cd301f6adb84b00cc7eb6be88d1b536';
const css = `._container_9eudb_1 {
  position: relative;
  z-index: 1;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"container":"_container_9eudb_1"};
export { css, digest };
  